import 'uni-pages';
import Vue from 'vue'
import Page from './pages/personalCenter/activity/detail.vue'
createPage(Page)